import { render, staticRenderFns } from "./VolcEngine.vue?vue&type=template&id=c5255ad0&"
import script from "./VolcEngine.vue?vue&type=script&lang=js&"
export * from "./VolcEngine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports